import { render, staticRenderFns } from "./TaskHistoryDrawer.vue?vue&type=template&id=10f924fb&scoped=true"
import script from "./TaskHistoryDrawer.vue?vue&type=script&lang=js"
export * from "./TaskHistoryDrawer.vue?vue&type=script&lang=js"
import style0 from "./TaskHistoryDrawer.vue?vue&type=style&index=0&id=10f924fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f924fb",
  null
  
)

export default component.exports